import { useNavigate } from 'react-router';

import { sendLogoutRequest } from '@/app/api';

import { ArrowLeftEndOnRectangleIcon } from '@heroicons/react/24/outline';

const LogoutButton = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    sendLogoutRequest().then(() => navigate('/login'));

    if (window.electron) {
      window.electron.send('logout');
    }
  };

  return (
    <button
      className="flex items-center w-full p-2 rounded-md hover:bg-gray-100 cursor-pointer"
      onClick={handleLogout}>
      <ArrowLeftEndOnRectangleIcon className="size-5 text-gray-600 mr-3" />
      Log ud
    </button>
  );
};

export default LogoutButton;
